<div class="card-body  widget-body pb-0 pt-2 mb-4" style="min-height: 400px;">
    <div class="row">
        <div class="col-lg-2">
            Filter
        </div>
        <div class="col-lg-4">
            <input type="radio" name="active" value="active" [(ngModel)]="AuthRelation.TypeFilter"
                (change)="getAuthorizationdata()">
            Active
            <input type="radio" name="expired" value="expired" [(ngModel)]="AuthRelation.TypeFilter"
                (change)="getAuthorizationdata()"> Expired

            <input type="radio" name="all" value="all" [(ngModel)]="AuthRelation.TypeFilter"
                (change)="getAuthorizationdata()"> All
        </div>
        <div class=" col-lg-6 text-end">
            <button type="button" class="btn btn-sm" (click)="AddAuthorization('new','00000000-0000-0000-0000-000000000000')"
                [disabled]="this.global.viewTabs"  *ngIf="fp.authorizationcreate" >
                <!-- *ngIf="fp.authorizationcreate" -->
                Add Authorization
            </button>
        </div>
    </div>
     <!-- 
                                                                          When adding/removing columns to this grid:
                                                                          1. Update AuthorizationTotalColumns constant in client.authorization.component.ts
                                                                          2. This prevents localStorage persistence conflicts
                                                                          3. Grid ID 'AuthListGrid' maps to localStorage key 'gridAuthListGrid'
                                                                          -->
    <ejs-grid #grid id="AuthListGrid" [dataSource]='data|async' [allowResizing]='true' allowPaging='true' [allowFiltering]='true'
         [allowReordering]="true" 
                  [enablePersistence]="true"  (rowDataBound)='rowDataBound($event)' [pageSettings]='initialPage' [filterSettings]='filterOptions'
        (actionBegin)="onActionComplete($event)" (dataStateChange)='dataStateChange($event)'
        (resizeStop)="onResize($event)" [showColumnChooser]='true'>
        <e-columns>
            <e-column width=150 uid="action" headerText="Actions">
                <ng-template #template let-data>
                    <!-- *ngIf="fp.authorizationupdate -->
                    <button class="btn btn-edit-table" (click)="AddAuthorization('edit',data)"  
                    *ngIf="fp.authorizationupdate" 
                        [disabled]="this.global.viewTabs"><i
                            class="fa fa-edit"></i></button>&nbsp;
                    <!-- <button type="button" class="btn btn-edit-table" (click)="AddAuthorization('addfrequency',data)" ><i
                                class="fa fa-plus"></i></button>&nbsp; -->
                    <button class=" btn btn-delete-table me-2" (click)="AddAuthorization('delete',data)"
                        [disabled]="this.global.viewTabs"  *ngIf="fp.authorizationdelete" >
                        <i class="fa fa-trash fa-lg"></i></button>
                        <!-- *ngIf="fp.authorizationdelete" -->
                    <button class="btn btn-edit-table me-2 text-center"
                        [disabled]="data.authDetailId==null || data.authDetailId==undefined || data.authDetailId==''"
                        (click)="generateSFTPAuthFile(data)">
                        <i class="fa fa-eye"></i>
                    </button>
                </ng-template>
            </e-column>
            <e-column width=100 field="startDate" headerText="Start Date" type='date' [format]='formatOptions'>
            </e-column>
            <e-column width=100 field="endDate" headerText="End Date" type='date' [format]='formatOptions'>
            </e-column>
            <e-column width=100 field="companyName" headerText="Company Name" type='string'>
                <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
            </e-column>
            <e-column width=100 field="payorName" headerText="Payor Name" type='string'>
                <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
            </e-column>
            <e-column width=100 field="insuranceNo" headerText="Insurance Number" type='string'>
                <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
            </e-column>
            <!-- <e-column width=100 field="authImportType" headerText="AuthorizationImportType" type='string'>
                <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
            </e-column> -->

            <!-- <e-column width=100 field="authUsedTimesheetTypeName" headerText="AuthorizationTimesheetImportType" type='string'>
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column> -->

            <!-- <e-column width=100 field="authLimitType" headerText="Auth Limit" type='string'>
                <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
            </e-column>
             -->


            <e-column width=100 field="serviceAgreementNo" headerText="Service Agreement#" type='string'>
                <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
            </e-column>
            <e-column width=100 field="serviceCode" headerText="Service Code" type='string'>
                <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
            </e-column>
            <e-column width=100 field="serviceDescription" headerText="Description" type='string'>
                <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                </ng-template>
            </e-column>
            <e-column width=100 field="totalUnits" headerText="Total units" type='number'></e-column>
            <e-column width=100 field="totalUnitsperday" headerText="Hours Per Day" [allowFiltering]="false">
            </e-column>
            <e-column width=100 field="totalUnitsperweek" headerText="Hours Per Week" [allowFiltering]="false">
            </e-column>
            <e-column Width=100 field="unitsUsed" headerText="Units Used" [allowFiltering]="false">
            </e-column>
            <e-column Width=100 field="unitsRemaining" headerText="Units Remaining" [allowFiltering]="false">
            </e-column>
            <!-- <e-column Width=100 field="remainingunitsPerDay" headerText="Units Remaining per Day from last DOB"
                [allowFiltering]="false">
            </e-column>
            <e-column Width=100 field="remainingUnitsPerWeek" headerText="Units/Week Billed"
                [allowFiltering]="false">
            </e-column> -->



            <!-- <e-column Width=100 field="remaininghours" headerText="Remaining Hours" [allowFiltering]="false">
            </e-column> -->
             <e-column Width=100 field="remainunitparDay" headerText="Remaining Hours per Day" [allowFiltering]="false">
            </e-column>
            <e-column Width=100 field="remainunitperWeek" headerText="Remaining Hours per Week"
                [allowFiltering]="false">
            </e-column>
            <!-- 
            <e-column Width=100 field="remaingHoursPerDayBasedOnLastVisitDatevalues"
                headerText="Remaining Hours Per Day Based on LastVisitDate" [allowFiltering]="false">
            </e-column>
            <e-column Width=100 field="remaingHoursPerWeekBasedOnLastVisitDatevalues"
                headerText="Remaining Hours Per Week Based on LastVisitDate" [allowFiltering]="false">
            </e-column>
            <e-column Width=100 field="confirmedUnits" headerText="Confirmed Units" [allowFiltering]="false">
            </e-column>
            <e-column Width=100 field="unconfirmedUnits" headerText="UnConfirmed Units" [allowFiltering]="false">
            </e-column> -->
            <e-column width="50" [showInColumnChooser]='false'>
                <ng-template #headerTemplate let-data>
                    <div class="d-none d-lg-block">
                        <span id='show' (click)='show()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                            </i></span>
                    </div>
                </ng-template>
            </e-column>
        </e-columns>
    </ejs-grid>
     <!-- 
                                                                          When adding/removing columns to this grid:
                                                                          1. Update AuthorizationTotalColumns constant in client.authorization.component.ts
                                                                          2. This prevents localStorage persistence conflicts
                                                                          3. Grid ID 'AuthListGrid' maps to localStorage key 'gridAuthListGrid'
                                                                          -->
</div>


<span id="openPdfModal" data-bs-target="#PDFModal" data-bs-toggle="modal"></span>
<div class="modal fade" id="PDFModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"
    data-bs-backdrop="static">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span> View
                        Pdf </span>

                </h5>
                &nbsp;&nbsp;
                <button type="button" class="btn blue-btn btn-sm ms-4" (click)="DownloadPDF()">
                    Download
                </button>
                <button type="button" (click)="closePdf()" class="btn-close" aria-label="Close">
                    <span aria-hidden="true"> </span>
                </button>
            </div>
            <div class="modal-body">
                <pdf-viewer [src]="FileURl" [render-text]="true" style="display: block;height:500px"></pdf-viewer>
            </div>
            <div class="modal-footer">

                <button type="button" class="btn blue-btn btn-sm" (click)="closePdf()">Close</button>
            </div>
        </div>
    </div>
</div>